export default "__VITE_ASSET__BOA7ZxCL__"